class ShowMore extends HTMLElement {
  constructor() {
    super();
    this.initShowMore();
  }

  initShowMore() {
    const showMoreButtons = this.querySelectorAll("#show-more");
    const showMoreContents = this.querySelectorAll(".ako-show-more-content");

    showMoreButtons.forEach((showMoreButton, index) => {
      const showMoreContent = showMoreContents[index];

      showMoreButton.addEventListener("click", () => {
        if (showMoreContent.classList.contains("content-open")) {
          showMoreContent.classList.remove("content-open");
          showMoreButton.querySelector("span.text").textContent = showMoreText;

          const position =
            showMoreContent.offsetHeight + window.innerHeight + 500;
          window.scrollTo({
            top: position,
            behavior: "smooth",
          });
        } else {
          showMoreContent.classList.add("content-open");
          showMoreButton.querySelector("span.text").textContent = showLessText;
        }
      });
    });
  }
}

window.customElements.define("show-more", ShowMore);
